// need to add dialog that Charlier is reaching goal of becoming a chef
const charlieGameDialogDataset = {
  friendName: "Charlie",
  dialogTable: [
    {dialogNbr: 1, title: "Charlie Introduction",
     text: "Hey! I'm Charlie, your nextdoor neighbor. Thought I'd stop by and say hi. Maybe we can hang out sometime?",
     conditionList: [],
     responses: [
       {rspText: "Sorry, I’m busy right now, maybe later.", moodPoints: -2, rltnPoints: -1},
       {rspText: "Sure, come on in! I’d love to chat.", moodPoints: 2, rltnPoints: 2}
     ]},

    {dialogNbr: 2, title: "Nice Apartment",
     text: "I just moved in a few months ago from my parents'. Loving the freedom! How do you like your apartment?",
     conditionList: [],
     responses: [
       {rspText: "It’s nothing special, just the basics really.", moodPoints: -1, rltnPoints: -1},
       {rspText: "I really love it, feels very cozy.", moodPoints: 2, rltnPoints: 1}
     ]},

    {dialogNbr: 3, title: "Something smells good",
     text: "Hey! I caught a yummy smell. Mind if I hang out and share a bite?",
     conditionList: [],
     responses: [
       {rspText: "Come on in, I’m happy to share.", moodPoints: 3, rltnPoints: 2},
       {rspText: "Sorry, there isn’t enough to share today.", moodPoints: -2, rltnPoints: -2}
     ]},

    {dialogNbr: 4, title: "Lost my job",
     text: "Ugh, I just got fired. Mind if I stay a bit? I could use a friend right now.",
     conditionList: [],
     responses: [
       {rspText: "Come in, let’s talk and figure things out.", moodPoints: 1, rltnPoints: 2},
       {rspText: "Sorry, I really can’t talk at the moment.", moodPoints: -2, rltnPoints: -3}
     ]},

    {dialogNbr: 5, title: "Join him for dinner",
     text: "I have leftovers from last night. Want to come over and share?",
     conditionList: [],
     responses: [
       {rspText: "I already ate, maybe another time soon.", moodPoints: -2, rltnPoints: -1},
       {rspText: "Sounds great! I’d love to join you.", moodPoints: 2, rltnPoints: 1}
     ]},

    {dialogNbr: 6, title: "New job",
     text: "Exciting news! I got a new job as a waiter at a local restaurant.",
     conditionList: [],
     responses: [
       {rspText: "That’s awesome news! We should celebrate soon.", moodPoints: 2, rltnPoints: 2},
       {rspText: "A waiter job? That seems a bit surprising.", moodPoints: -2, rltnPoints: -2}
     ]},

    {dialogNbr: 7, title: "Job as a Chef",
     text: "I've been at culinary school. Once I graduate, I'll be a chef apprentice!",
     conditionList: [],
     responses: [
       {rspText: "Great plan! You’ll make an amazing chef someday.", moodPoints: 2, rltnPoints: 2},
       {rspText: "We’ll see how things go after graduation.", moodPoints: -1, rltnPoints: -2}
     ]},

    {dialogNbr: 8, title: "Loaning money to Charlie",
     text: "Can you lend me $500? I just started my job and I'm short, but I’ll pay back soon.",
     conditionList: [],
     responses: [
       {rspText: "Sorry, I can’t help with money right now.", moodPoints: -3, rltnPoints: -3, loanedMoney: false},
       {rspText: "Sure, I can lend you the money now.", on: "cashOnly", moodPoints: -2, rltnPoints: 5, cashAmt: -500, triggerCondition: "loaned-charlie-money"}
     ]},

    {dialogNbr: 9, title: "Go for a walk",
     text: "Want to go for a walk? It's free, good for talking and stretching.",
     conditionList: [],
     responses: [
       {rspText: "Sure, let’s go for a walk together.", moodPoints: 2, rltnPoints: 1},
       {rspText: "Not right now, maybe some other time.", moodPoints: -2, rltnPoints: -2}
     ]},

    {dialogNbr: 10, title: "Charlie pays back loan",
     text: "I’m here with the $500 I borrowed. Want to grab dinner to say thanks?",
     conditionList: ["loaned-charlie-money"], type: "in-person",
     responses: [
       {rspText: "Thanks! Let’s go eat and catch up.", moodPoints: 3, rltnPoints: 2, cashAmt: 500, deleteCondition: "loaned-charlie-money"},
       {rspText: "I appreciate it, but I’ll skip dinner tonight.", moodPoints: 2, rltnPoints: -2, cashAmt: 500, deleteCondition: "loaned-charlie-money"}
     ]},

    {dialogNbr: 11, title: "401(k) Saving",
     text: "I set up a 401(k). Starting early seems smart for retirement savings!",
     conditionList: [],
     responses: [
       {rspText: "Good idea! You’re thinking smart for later.", moodPoints: 1, rltnPoints: 1},
       {rspText: "That seems like a waste of time honestly.", moodPoints: -1, rltnPoints: -2}
     ]},

    {dialogNbr: 12, title: "Go back to school?",
     text: "Your job is smart! Have you thought of going back to school to earn more?",
     conditionList: ["no-college"], type: "in-person",
     responses: [
       {rspText: "No college for me, not planning that.", moodPoints: -2, rltnPoints: 0},
       {rspText: "Maybe I will go back eventually.", moodPoints: 2, rltnPoints: 1}
     ]},

    {dialogNbr: 13, title: "College paid off",
     text: "Your college work seems to be paying off at your job!",
     conditionList: ["4-years-college"], type: "in-person",
     responses: [
       {rspText: "I’m glad I went to college, really helped.", moodPoints: 2, rltnPoints: 1},
       {rspText: "Yeah, I guess it did pay off a bit.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 14, title: "401(k) Saving Too much",
     text: "I overdid my 401(k) contributions and had to withdraw $2000. Transfer fees were $400!",
     conditionList: [],
     responses: [
       {rspText: "That’s rough! Hopefully next time will be better.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Not smart, you really lost money here.", moodPoints: -1, rltnPoints: -2}
     ]},

    {dialogNbr: 15, title: "401(k) Interest Earned",
     text: "Good news! I earned $200 on my 401K... sooo...the $400 withdrawal only cost $200 in the end.",
     conditionList: [],
     responses: [
       {rspText: "Nice! At least you still earned some interest.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Hmm, okay. That barely helps in the end.", moodPoints: 1, rltnPoints: -2}
     ]},

    {dialogNbr: 16, title: "Graduating Soon",
     text: "Only 3 months left in school! Can't wait to graduate!",
     conditionList: [],
     responses: [
       {rspText: "It’s been a long road to get here.", moodPoints: -1, rltnPoints: -2},
       {rspText: "Congrats! Soon you’ll be a skilled chef.", moodPoints: 1, rltnPoints: 1}
     ]},

    {dialogNbr: 17, title: "401(k) Saving Amount Adjusted",
     text: "Adjusted my 401(k) savings to avoid future transfers. Fingers crossed!",
     conditionList: [],
     responses: [
       {rspText: "Finally fixed it, hopefully no more issues.", moodPoints: -1, rltnPoints: -1},
       {rspText: "Good job! That should help your savings.", moodPoints: 2, rltnPoints: 2}
     ]},

    {dialogNbr: 18, title: "Fix you Dinner",
     text: "Want me to cook you something? I added a creative twist I learned at culinary school.",
     conditionList: [],
     responses: [
       {rspText: "Not the first try, maybe next time.", moodPoints: -2, rltnPoints: -1},
       {rspText: "Sure, sounds great! I can’t wait.", moodPoints: 2, rltnPoints: 2}
     ]},

    {dialogNbr: 19, title: "Credit Card Setup",
     text: "I finally got a credit card. Paying minimum each month, feels like free money!",
     conditionList: [],
     responses: [
       {rspText: "Great! Now you can build some credit history.", moodPoints: -2, rltnPoints: 1},
       {rspText: "That’s a bad idea for your finances.", moodPoints: 2, rltnPoints: -1}
     ]},

    {dialogNbr: 20, title: "Let's Go Out",
     text: "Wanna go out to dinner? My treat on the credit card.",
     conditionList: [],
     responses: [
       {rspText: "Absolutely! I’d love to go out tonight.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Too tired, maybe another day works better.", moodPoints: -2, rltnPoints: -1}
     ]},

    {dialogNbr: 21, title: "Credit Card Trouble",
     text: "Bank froze my credit card. I owe $5000, half is interest! Yikes!",
     conditionList: [],
     responses: [
       {rspText: "Told you, you need to be careful.", moodPoints: -1, rltnPoints: -1},
       {rspText: "Wow, that’s really rough, hope it improves.", moodPoints: -1, rltnPoints: 1}
     ]},

    {dialogNbr: 22, title: "Credit Card Loan to Charlie",
     text: "Can you loan me $1000 to pay my card? I’ll pay back soon after graduation and promotion.",
     conditionList: [],
     responses: [
       {rspText: "No way, I can’t lend that much money.", moodPoints: -3, rltnPoints: -3},
       {rspText: "I can help you out with the loan.", moodPoints: -2, rltnPoints: 5, cashAmt: -1000, triggerCondition: "loaned-charlie-money"}
     ]},

    {dialogNbr: 23, title: "Promise to Pay Back Loan",
     text: "With the money you lent me and my savings, I’ve reduced my credit card balance.",
     conditionList: ["loaned-charlie-money"],
     responses: [
       {rspText: "Thanks for the update, I appreciate it.", moodPoints: -1, rltnPoints: 1},
       {rspText: "I expected more, but it’s a start.", moodPoints: -2, rltnPoints: -2}
     ]},

    {dialogNbr: 24, title: "Celebration dinner",
     text: "I graduated! My boss said I’ll get promoted soon. Want to celebrate? Nothing fancy!",
     conditionList: [],
     responses: [
       {rspText: "Sure, let's go and celebrate together tonight.", moodPoints: 1, rltnPoints: 1, cashAmt: 37.56, itemDesc: "Food Bonanza Restaurant"},
       {rspText: "Not right now, maybe another time works.", moodPoints: -2, rltnPoints: -1}
     ]},

    {dialogNbr: 25, title: "Pay Back Part of Loan",
     text: "Here’s $500 back. I’ll pay the rest next month.",
     conditionList: ["loaned-charlie-money"],
     responses: [
       {rspText: "Bad idea lending money, it’s risky.", moodPoints: -3, rltnPoints: -2, cashAmt: 500},
       {rspText: "Thanks for paying something back, I appreciate it.", moodPoints: -1, rltnPoints: 1, cashAmt: 500}
     ]},

    {dialogNbr: 26, title: "Pay Back Rest of Loan",
     text: "Here’s the rest of your money. Really appreciate your help!",
     conditionList: ["loaned-charlie-money"],
     responses: [
       {rspText: "Glad I could help you out completely.", moodPoints: 1, rltnPoints: 2, cashAmt: 500, deleteCondition: "loaned-charlie-money"},
       {rspText: "Late, but okay, I understand the delay.", moodPoints: -2, rltnPoints: -2, cashAmt: 500, deleteCondition: "loaned-charlie-money"}
     ]},

    {dialogNbr: 27, title: "Credit Card Change",
     text: "I changed my credit card policy. Now I’ll pay the full balance monthly.",
     conditionList: [],
     responses: [
       {rspText: "Hope it works out well for you.", moodPoints: 1, rltnPoints: -1, cashAmt: 0, deleteCondition: ""},
       {rspText: "Good plan! That should help a lot.", moodPoints: 2, rltnPoints: 1, cashAmt: 0, deleteCondition: ""}
     ]},

    {dialogNbr: 28, title: "Let's Celebrate",
     text: "I got promoted! Apprentice chef now. Want to celebrate?",
     conditionList: [],
     responses: [
       {rspText: "Congrats! I’m so happy for your promotion.", moodPoints: 2, rltnPoints: 2, cashAmt: -35.90, deleteCondition: ""},
       {rspText: "Can’t celebrate now, maybe later works better.", moodPoints: -2, rltnPoints: -2, cashAmt: 0, deleteCondition: ""}
     ]},

    {dialogNbr: 29, title: "Financial Plan",
     text: "Talked to a financial advisor. Learned to make a long-term savings plan. Exciting!",
     conditionList: [],
     responses: [
       {rspText: "Great idea! Planning ahead will really help.", moodPoints: 1, rltnPoints: 1, cashAmt: 0, deleteCondition: ""},
       {rspText: "Too young to worry about it right now.", moodPoints: 2, rltnPoints: -2, cashAmt: 0, deleteCondition: ""}
     ]},

    {dialogNbr: 30, title: "Dinner Invite",
     text: "Hosting a 5-course dinner for friends. Want to come?",
     conditionList: [],
     responses: [
       {rspText: "No thanks, maybe another time would be good.", moodPoints: -2, rltnPoints: -3, cashAmt: 0, deleteCondition: ""},
       {rspText: "Count me in! I’d love to join you.", moodPoints: 2, rltnPoints: 2, cashAmt: 0, deleteCondition: ""}
     ]},

    {dialogNbr: 31, title: "Savings Goal",
     text: "Finished my long-term money plan. Saving $100 more/month = retire at 60! Cool, right?",
     conditionList: [], cashAmt: 0, deleteCondition: "",
     responses: [
       {rspText: "Wow, nice! That’s an impressive savings plan.", moodPoints: 2, rltnPoints: 1, cashAmt: 0, deleteCondition: ""},
       {rspText: "Unlikely, I don’t think it will work easily.", moodPoints: -1, rltnPoints: -2, cashAmt: 0, deleteCondition: ""}
     ]},
     {dialogNbr: 32, title: "Early Kitchen Mishap",
 text: "I tried making a new sauce at work today… and nearly ruined the whole batch!",
 conditionList: [],
 responses: [
   {rspText: "Oh no! That sounds like a disaster waiting to happen.", moodPoints: -2, rltnPoints: -1},
   {rspText: "Haha, at least you tried something new, that’s fun!", moodPoints: 2, rltnPoints: 2}
 ]},

{dialogNbr: 33, title: "Funny Cooking Story",
 text: "Guess what? I accidentally added sugar instead of salt in the soup! My coworkers still laughed.",
 conditionList: [],
 responses: [
   {rspText: "Wow, hope it didn’t taste too bad!", moodPoints: -1, rltnPoints: 0},
   {rspText: "Haha, sounds hilarious! I’d try that by accident too.", moodPoints: 2, rltnPoints: 2}
 ]},

{dialogNbr: 34, title: "Saving Tip Learned",
 text: "I just realized I can save money by prepping meals at home instead of eating out every day.",
 conditionList: [],
 responses: [
   {rspText: "Smart thinking! That will save a lot over time.", moodPoints: 2, rltnPoints: 1},
   {rspText: "Eh, it sounds like too much work for little benefit.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 35, title: "Borrowing Again",
 text: "Hey, I’m short on cash this week… could you lend me $100? I promise to pay back with interest.",
 conditionList: [],
 responses: [
   {rspText: "I’m not sure, lending again might be risky.", moodPoints: -2, rltnPoints: -1},
   {rspText: "Sure, here’s the money. Just don’t forget to pay back.", moodPoints: -1, rltnPoints: 4, cashAmt: -100, triggerCondition: "loaned-charlie-money"}
 ]},

{dialogNbr: 36, title: "Dinner in Lieu of Money",
 text: "I can’t pay you all back yet, but how about I cook you a special 3-course dinner instead?",
 conditionList: ["loaned-charlie-money"],
 responses: [
   {rspText: "Hmm… okay, I’ll take a dinner instead of cash.", moodPoints: 1, rltnPoints: 2},
   {rspText: "No, I really need my money back.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 37, title: "Work Promotion Hint",
 text: "My boss said I’m doing really well… maybe a promotion soon if I keep up this pace!",
 conditionList: [],
 responses: [
   {rspText: "That’s exciting! You deserve it with all your effort.", moodPoints: 2, rltnPoints: 2},
   {rspText: "Don’t get too excited until it actually happens.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 38, title: "Culinary School Project",
 text: "I’m experimenting with a new dessert recipe for my culinary class. Want to taste-test it?",
 conditionList: [],
 responses: [
   {rspText: "Absolutely! I’m excited to try your dessert.", moodPoints: 2, rltnPoints: 2},
   {rspText: "I’ll pass this time, maybe next experiment.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 39, title: "Learning About Budgeting",
 text: "I tried making a monthly budget… and realized I spend way too much on spices and ingredients!",
 conditionList: [],
 responses: [
   {rspText: "Haha, cooking supplies can really add up quickly.", moodPoints: 1, rltnPoints: 1},
   {rspText: "Maybe you should rethink your hobby spending.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 40, title: "First Chef Task",
 text: "Today I got to prep ingredients for the head chef directly! Felt like a real responsibility.",
 conditionList: [],
 responses: [
   {rspText: "Congrats! That’s a big step forward.", moodPoints: 2, rltnPoints: 2},
   {rspText: "Just prep, not much else. Don’t get too excited.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 41, title: "Funny Customer Story",
 text: "A customer asked for a ‘surprise dish’… I improvised and they actually loved it!",
 conditionList: [],
 responses: [
   {rspText: "That’s amazing! Sounds like you’re a natural.", moodPoints: 2, rltnPoints: 2},
   {rspText: "Hope it wasn’t too risky, could have gone badly.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 42, title: "Small Loan Paid Back",
 text: "I finally managed to pay you back the $100 I borrowed last week!",
 conditionList: ["loaned-charlie-money"],
 responses: [
   {rspText: "Thanks for paying it back on time, I appreciate it.", moodPoints: 2, rltnPoints: 2, cashAmt: 100, deleteCondition: "loaned-charlie-money"},
   {rspText: "About time! Glad you finally returned it.", moodPoints: -1, rltnPoints: -1, cashAmt: 100, deleteCondition: "loaned-charlie-money"}
 ]},

{dialogNbr: 43, title: "Trying a New Recipe",
 text: "I’m practicing a new fish dish. It’s tricky, but I love the challenge!",
 conditionList: [],
 responses: [
   {rspText: "Sounds delicious! Can’t wait to try it.", moodPoints: 2, rltnPoints: 2},
   {rspText: "Fish? Not my favorite, but good luck anyway.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 44, title: "Learning from Mistakes",
 text: "I overcooked a steak today… but my boss showed me how to fix it. Lesson learned!",
 conditionList: [],
 responses: [
   {rspText: "That’s how you get better, mistakes are learning!", moodPoints: 2, rltnPoints: 2},
   {rspText: "Too bad, hope it doesn’t happen again.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 45, title: "Promotion Achieved",
 text: "I’m officially promoted to Junior Chef! I can’t believe it, all the hard work paid off!",
 conditionList: [],
 responses: [
   {rspText: "Congrats! You’re really moving up fast.", moodPoints: 3, rltnPoints: 2},
   {rspText: "Finally! You deserved it, hope it lasts.", moodPoints: 2, rltnPoints: 1}
 ]},

{dialogNbr: 46, title: "Preparing a Feast",
 text: "I’m preparing a special 5-course meal at work today. Feeling like a real chef!",
 conditionList: [],
 responses: [
   {rspText: "Wow, can’t wait to taste your creations!", moodPoints: 3, rltnPoints: 2},
   {rspText: "Sounds stressful! Hope you can handle it all.", moodPoints: -1, rltnPoints: -1}
 ]},

{dialogNbr: 47, title: "First Solo Dish",
 text: "Today I cooked a dish completely on my own for the first time! Chef-in-training vibes.",
 conditionList: [],
 responses: [
   {rspText: "Amazing! That’s a huge milestone, bravo!", moodPoints: 3, rltnPoints: 2},
   {rspText: "Careful, hope it turned out edible!", moodPoints: -1, rltnPoints: -1}
 ]}

  ]
};

export default charlieGameDialogDataset;

